import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy
  } from '@angular/core';
  import {MatCalendar} from '@angular/material/datepicker';
  import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
  import {Subject} from 'rxjs';
  import {takeUntil} from 'rxjs/operators';
  
  /** Custom header component for datepicker. */
  @Component({
    selector: 'calendar-header',
    styles: [`
      @import 'colors';

      .calendar-header {
        display: flex;
        align-items: center;
        padding: 0.5em;
      }
  
      .calendar-header-label {
        flex: 1;
        font-size: 1.4rem;
        font-weight: 500;
        color: $gray-6;
        text-align: center;
      }
  
      .example-double-arrow .mat-icon {
        margin: -22%;
        font-size: 1.4rem;
      }
    `],
    template: `
      <div class="calendar-header">
        <app-button variant="link" color="default" (click)="previousClicked('month')">
          <span class="material-icons">keyboard_arrow_left</span>
        </app-button>
        <span class="calendar-header-label">{{periodLabel}}</span>
        <app-button variant="link" color="default" (click)="nextClicked('month')">
          <span class="material-icons">keyboard_arrow_right</span>
        </app-button>
      </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class CalendarHeader<D> implements OnDestroy {
    private _destroyed = new Subject<void>();
  
    constructor(
        private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>,
        @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats, cdr: ChangeDetectorRef) {
      _calendar.stateChanges
          .pipe(takeUntil(this._destroyed))
          .subscribe(() => cdr.markForCheck());
    }
  
    ngOnDestroy() {
      this._destroyed.next();
      this._destroyed.complete();
    }
  
    get periodLabel() {
      return this._dateAdapter
          .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
          .toLocaleUpperCase();
    }
  
    previousClicked(mode: 'month' | 'year') {
      this._calendar.activeDate = mode === 'month' ?
          this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
          this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
    }
  
    nextClicked(mode: 'month' | 'year') {
      this._calendar.activeDate = mode === 'month' ?
          this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
          this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
    }
  }
  
  
  /**  Copyright 2020 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license */